export default {
  s: '%d seconde',
  smicro: '%d s',
  smid: '%d sec',

  ss: '%d seconden',
  ssmicro: '%d s',
  ssmid: '%d sec',

  m: '%d minuut',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d minuten',
  mmmicro: '%d m',
  mmmid: '%d min',

  h: '%d uur',
  hmicro: '%d u',
  hmid: '%d uur',

  hh: '%d uur',
  hhmicro: '%d u',
  hhmid: '%d uur',

  d: '%d dag',
  dmicro: '%d d',
  dmid: '%d dag',

  dd: '%d dagen',
  ddmicro: '%d d',
  ddmid: '%d dagen',
};
